// src/pages/manager/ManagerMessagesPage.js
import React, { useState, useEffect } from 'react';
import { auth, db } from '../../firebase';
import { collection, getDocs, query, where, doc, getDoc } from 'firebase/firestore';
import SendMessageForm from '../../SendMessageForm';
import MensagensEnviadas from '../../MensagensEnviadas';
import { Divider, CircularProgress, Box } from '@mui/material';

function ManagerMessagesPage() {
    const user = auth.currentUser;
    const [parceiros, setParceiros] = useState([]);
    const [managerName, setManagerName] = useState('Gerente');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            if (!user) return;
            // Pega nome do gerente
            const managerDoc = await getDoc(doc(db, "usuarios", user.uid));
            if (managerDoc.exists()) setManagerName(managerDoc.data().nome);

            // Pega parceiros vinculados
            const q = query(collection(db, "usuarios"), where("gerenteId", "==", user.uid));
            const data = await getDocs(q);
            const lista = data.docs.map(doc => ({ ...doc.data(), id: doc.id }));
            lista.sort((a, b) => (a.nome || '').localeCompare(b.nome || '', 'pt-BR'));
            setParceiros(lista);
            setLoading(false);
        };
        fetchData();
    }, [user]);

    if (loading) return <Box sx={{ display: 'flex', justify: 'center', p: 3 }}><CircularProgress /></Box>;

    return (
        <>
            <SendMessageForm 
                user={user} 
                recipientList={parceiros} 
                senderName={managerName} 
            />
            
            <Divider sx={{ my: 4 }} />
            
            <MensagensEnviadas user={user} />
        </>
    );
}

export default ManagerMessagesPage;